import { useEffect, useRef, useState } from "react"
import { useGestionConocimientos } from "../../../hooks/gestionConocimientos/useGestionConocimientos"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { BotonNuevo } from "../../components/buttons/BotonNuevo"
import { Tooltip } from "../../components/utils/Tooltip"
import { BotonProcesar } from "../../components/buttons/BotonProcesar"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { obtenerEstado } from "../../../utils/utils"
import { Modal } from "../../components/modal/Modal"
import { useModal } from "../../../hooks/useModal"
import { EditorTexto } from "../../components/utils/EditorTexto"

export const DocumentacionTecnica = () => {


    const [ isOpenModalDocumentacion, openModalDocumentacion, closeModalDocumentacion ] = useModal(null);
    const [ isOpenModalEliminarDocumentacion, openModalEliminarDocumentacion, closeModalEliminarDocumentacion ] = useModal(null);
    const [ contenido, setContenido ] = useState('');
    const [ valueEditor, setValueEditor ] = useState('');
    const datosEliminarDefault = {
        codGestionConocimiento: 0,
        motivoEliminacion: ""
    }
    const [ datosEliminar, setDatosEliminar ] = useState(datosEliminarDefault)
    const editarValorEliminacion = (key,value) =>{
        setDatosEliminar(leccion => {
            return {
                ...leccion,
                [key]: value
            }
        })
    }

    const idTabla = 'TablaDocumentacion';
    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";

    const {
        listarDocumentacionTecnica,
        documentacionesTecnica,
        listarDetalleDocumentacion,
        detalleDocumentacion,
        listarTipoDocumentacion,
        listaTipoDocumentacion,
        listarServicios,
        listaServicio,
        listarNivelConfidencialidad,
        listaNivelConfidencialidad,
        editarValorDocumentacion,
        guardarEditarDocumentacion,
    } = useGestionConocimientos();

    const registrarDocumentacion = async () => {
        const isValid = await guardarEditarDocumentacion();
        if(isValid)
        {
            listarDocumentacionTecnica();
            closeModalDocumentacion();
        }
    }


    useEffect(() => {
        listarNivelConfidencialidad();
        listarServicios();
        listarTipoDocumentacion();
        listarDocumentacionTecnica();
    },[])
    useEffect(()=>{
        console.log('valor editor: ',valueEditor)
    },[valueEditor])

    return(
        <>
            <ContenedorParametros
                titulo='Inventario de documentación técnica'
                tablaId={idTabla}
            >
                <Tooltip id={"iconoEstado"}>Estados</Tooltip>
                <BotonNuevo
                    onClick={async () => {
                        await listarDetalleDocumentacion()
                        setValueEditor(detalleDocumentacion.observacion)
                        openModalDocumentacion()
                    }}
                />
                <BotonProcesar
                    onClick={()=> listarDocumentacionTecnica()}
                />
            </ContenedorParametros>
            <ContenedorTabla>
                <table id={idTabla} className="table">
                    <thead>
                        <tr>
                            <th>N</th>
                            <th>CÓDIGO</th>
                            <th>TITULO</th>
                            <th>APLICACION</th>
                            <th>PROYECTO</th>
                            <th>FECHA CREACIÓN</th>
                            <th>ESTADO</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            documentacionesTecnica.length > 0 ?
                                documentacionesTecnica.map((tec, i) => (
                                    <tr key={`fila-${i}`}>
                                        <td className="text-center w-[40px]">{i + 1}</td>
                                        <td className="text-center ">
                                            <span className="text-center w-[60px] bg-blue-600 rounded px-2 inline-block">{tec.codDocumentoTecnico}</span>
                                        </td>
                                        <td className="w-[300px]">
                                            <div className="whitespace-nowrap overflow-hidden text-ellipsis w-[95%]">{tec.titulo || ''}</div>
                                        </td>
                                        <td>{tec.nomAplicacion || ''}</td>
                                        <td>{tec.nomProyecto || ''}</td>
                                        <td className="text-center">{tec.fechaCreacion || ''}</td>
                                        <td className="text-center">{obtenerEstado(tec.codEstado, tec.nomEstado)}</td>
                                        <td className="text-center">
                                            <i
                                                className="fa fa-edit text-base text-blue-600"
                                                onClick={async ()=> {
                                                    listarDetalleDocumentacion(tec)
                                                    openModalDocumentacion()
                                                }}
                                            ></i>
                                        </td>
                                        <td className="text-center">
                                            <i className="fa fa-trash text-base text-red-600" onClick={()=> openModalEliminarDocumentacion()}></i>
                                        </td>
                                    </tr>
                                ))
                            :
                            <tr>
                                <td className="text-center" colSpan={9}>No hay información para mostrar...</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>

            <Modal
                isOpen={isOpenModalDocumentacion}
                closeModal={closeModalDocumentacion}
                action={()=> registrarDocumentacion()}
                title={`${detalleDocumentacion.codDocumentoTecnico == 0 ? "Nuevo registro" : `Editar documentación [ ${detalleDocumentacion.codDocumentoTecnico} ]`}`}
            >
                <section key={'contenedorDoc'} className=" w-[800px] grid grid-cols-[minmax(0,25fr)_minmax(0,25fr)_minmax(0,25fr)_minmax(0,25fr)] items-center gap-2 p-2">
                    <label htmlFor="titulo">Titulo</label>
                    <input
                        id="titulo"
                        className={`${classNameInput}`}
                        value={detalleDocumentacion.titulo}
                        onChange={(e)=> editarValorDocumentacion('titulo', e.target.value)}
                    />
                    <label htmlFor="aplicacion">Aplicación (servicio)</label>
                    <select
                        id="aplicacion"
                        className={`${classNameSelect}`}
                        value={detalleDocumentacion.codGestionInfraestructuraAplicacion}
                        onChange={(e) => editarValorDocumentacion('codGestionInfraestructuraAplicacion', Number(e.target.value))}
                    >
                        <option key={'opcionSeleccione'} value={0}>--Seleccione--</option>
                        {
                            listaServicio.length > 0 ? 
                                listaServicio.map(ls => (
                                    <option key={'aplicacion_' + ls.codGestionInfraestructuraAplicacion} value={ls.codGestionInfraestructuraAplicacion}>{ls.nomProyecto}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                    <label htmlFor="tipoDocumentacion">Tipo documentación</label>
                    <select
                        id="tipoDocumentacion"
                        className={`${classNameSelect}`}
                        value={detalleDocumentacion.codDocumentoTecnicoTipo}
                        onChange={(e) => editarValorDocumentacion('codDocumentoTecnicoTipo',Number(e.target.value))}
                    >
                        <option value={0} key={'opcionSeleccioneDoc'}>--Seleccione--</option>
                        {
                            listaTipoDocumentacion.length > 0 ?
                                listaTipoDocumentacion.map(tip => (
                                    <option key={'doc_' + tip.codDocumentoTecnicoTipo} value={tip.codDocumentoTecnicoTipo}>{tip.nomDocumentoTecnicoTipo}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                    <label htmlFor="listaNivelConfidencialidad">Nivel de confidencialidad</label>
                    <select
                        id="listaNivelConfidencialidad"
                        className={`${classNameSelect}`}
                        value={detalleDocumentacion.codNivelConfidencialidad}
                        onChange={(e) => editarValorDocumentacion('codNivelConfidencialidad',Number(e.target.value))}
                    >
                        <option key={'opcionSeleccioneConfidencialidad'} value={0}>--Seleccione--</option>
                        {
                            listaNivelConfidencialidad.length > 0 ? 
                                listaNivelConfidencialidad.map(conf => (
                                    <option key={'confid_' + conf.codNivelConfidencialidad} value={conf.codNivelConfidencialidad}>{conf.nomNivelConfidencialidad}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                    <label htmlFor="urlDoc">URL Documentación</label>
                    <input
                        id="urlDoc"
                        className={`${classNameInput}`}
                        value={detalleDocumentacion.urlDocumentacion}
                        onChange={(e) => editarValorDocumentacion('urlDocumentacion',e.target.value)}
                    />
                    <label htmlFor="etiqueta">Etiqueta</label>
                    <input 
                        id="etiqueta" 
                        className={`${classNameInput}`}
                        value={detalleDocumentacion.etiqueta}
                        onChange={(e) => editarValorDocumentacion('etiqueta', e.target.value)}
                    />
                    <label htmlFor="descripcion">Descripción</label>
                    <div className="col-span-3 w-full lg:h-[176px] editor-quill-container " key={'contentDescripcion'}>
                        <EditorTexto
                            keyEditor={'descripcion'}
                            setValueEdit={editarValorDocumentacion}
                            valueEdit={detalleDocumentacion.descripcion}
                        />
                    </div>
                    <label htmlFor="observacion">Observación</label>
                    <div className="col-span-3 w-full lg:h-[176px] editor-quill-container " key={'contentDescripcion'}>
                        <EditorTexto
                            keyEditor={'observacion'}
                            setValueEdit={editarValorDocumentacion}
                            valueEdit={detalleDocumentacion.observacion}
                        />
                    </div>
                </section>
            </Modal>


            {/* MODAL PARA ELIMINAR DOCUMENTACION */}
            <Modal
                isOpen={isOpenModalEliminarDocumentacion}
                closeModal={closeModalEliminarDocumentacion}
                // action={() => eliminar()}
                // title={`Eliminar dominio [${detalleDominio.codGestionInfraestructuraDominio}]`}
                // textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
            >
                <div className='grid gap-2 py-3 w-[350px]'>
                    <strong className="">Motivo:</strong>
                    <textarea
                        className={`${classNameInput}
                        h-[80px] resize-none`}
                        placeholder="Escriba aquí el motivo de la eliminación de leccion y aprendizaje..."
                        onChange={(e) => editarValorEliminacion('motivoEliminacion', e.target.value)}
                    />
                </div>
            </Modal>
        </>
    )
}